// Catálogos del seguimiento del embudo (sales_funnel_records).
// Se comparten entre el modal del detalle del producto y las columnas editables
// del listado de productos para que no se desincronicen.

export const TOUCH_OPTIONS = [
  { nombre: 'Primer toque', slug: 'primer-toque' },
  { nombre: 'Segundo toque', slug: 'segundo-toque' },
  { nombre: 'Tercer toque', slug: 'tercer-toque' },
  { nombre: 'Final', slug: 'final' }
]

export const CONTACT_METHOD_OPTIONS = [
  { nombre: 'WhatsApp', slug: 'whatsapp' },
  { nombre: 'Dashboard', slug: 'dashboard' },
  { nombre: 'Cara a cara', slug: 'cara-a-cara' },
  { nombre: 'Número inválido', slug: 'numero-invalido' }
]

export const OVERALL_STATUS_OPTIONS = [
  { nombre: 'Contactado', slug: 'contactado' },
  { nombre: 'No contactado', slug: 'no-contactado' },
  { nombre: 'No responde', slug: 'no-responde' },
  { nombre: 'En conversación', slug: 'en-conversacion' },
  { nombre: 'Interesado', slug: 'interesado' },
  { nombre: 'Rechazado', slug: 'rechazado' },
  { nombre: 'Cerró venta', slug: 'cerro-venta' }
]

export const REJECTION_REASON_OPTIONS = [
  { nombre: 'Por precio', slug: 'por-precio' },
  { nombre: 'Por glass', slug: 'por-glass' },
  { nombre: 'Por rayaduras', slug: 'por-rayaduras' },
  { nombre: 'Fuera de catálogo', slug: 'fuera-de-catalogo' },
  { nombre: 'Display', slug: 'display' },
  { nombre: 'Carcasa', slug: 'carcasa' },
  { nombre: 'Contorno', slug: 'contorno' },
  { nombre: 'Face ID', slug: 'face-id' },
  { nombre: 'Por bisagra', slug: 'por-bisagra' },
  { nombre: 'No acepta oferta', slug: 'no-acepta-oferta' },
  { nombre: 'Número inválido', slug: 'numero-invalido' }
]

export const ACQUISITION_CHANNEL_OPTIONS = [
  { nombre: 'Cara a cara (F2F)', slug: 'cara-a-cara-f2f' },
  { nombre: 'Recomendación', slug: 'recomendacion' },
  { nombre: 'Compraron en GivU', slug: 'compraron-en-givu' },
  { nombre: '2da venta', slug: 'segunda-venta' },
  { nombre: 'Instagram Orgánico', slug: 'instagram-organico' },
  { nombre: 'Facebook Orgánico', slug: 'facebook-organico' },
  { nombre: 'Facebook – Grupos de interés', slug: 'facebook-grupos' },
  { nombre: 'Facebook Ads', slug: 'facebook-ads' },
  { nombre: 'Google Ads (SEM)', slug: 'google-ads-sem' },
  { nombre: 'TikTok', slug: 'tiktok' },
  { nombre: 'Radio Disney', slug: 'radio-disney' },
  { nombre: 'Google Búsqueda Orgánica', slug: 'google-busqueda-organica' },
  { nombre: 'ChatGPT', slug: 'chatgpt' },
  { nombre: 'Código de alianza', slug: 'codigo-de-alianza' },
  { nombre: 'Código de referido', slug: 'codigo-de-referido' },
  { nombre: 'No sabe', slug: 'no-sabe' },
  { nombre: 'No responde', slug: 'no-responde' }
]

export const labelBySlug = (options, slug) => {
  if (!slug) return ''
  const option = options.find(opt => opt.slug === slug)
  return option ? option.nombre : slug
}
